<template>
  <validation-observer ref="step3Form" v-slot="{ }">
    <v-form>
      <validation-provider v-for="(field, index) in fields" :key="index" :name="field.label" :rules="field.required ? 'required' : ''" v-slot="{ errors }">
        <v-autocomplete
          v-if="field.name === 'languageCode'"
          :label="field.label"
          v-model="formValues[field.name]"
          filled
          required
          :items="allowedLanguageCodes"
          :class="{'required': field.required}"
          item-text="name"
          item-value="value"
          :error-messages="errors"
        >
          <template v-slot:selection="{ item }">
            {{languages[item].native}}
          </template>
          <template v-slot:item="{ item }">
            {{languages[item].native}}
          </template>
        </v-autocomplete>
        <v-text-field
          v-else
          :label="field.label"
          v-model="formValues[field.name]"
          filled
          required
          :class="{'required': field.required}"
          :error-messages="errors"
        ></v-text-field>
      </validation-provider>
    </v-form>
  </validation-observer>
</template>

<script>
import { camelCase } from 'lodash'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapState, mapGetters } from 'vuex'
import languages from '@/data/languages'
export default {
  data () {
    return {
      languages,
      formValues: {},
      isCompleted: false,
      loading: true,
    }
  },
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  computed: {
    ...mapGetters('me', ['allowedLanguageCodes', 'defaultLanguageCode']),
    fields () {
      if (!this.registrationCardConfiguration) {
        return []
      }
      let languageCode = this.$i18n.locale
      let contactData = this.registrationCardConfiguration.steps.find(step => step.type === 'CONTACT_DATA')
      return contactData.configuration.fields.map((field) => {
        let name = field.name.filter(name => name.languageCode === languageCode)[0]
        return {
          label: name.value,
          name: camelCase(field.fieldName),
          required: field.required,
        }
      })
    },
    ...mapState({
      registrationCardConfiguration: state => state.service.configuration ? state.service.configuration.registrationCardConfiguration : null,
      registrationCards: state => state.registrationCards,
      contactData: state => {
        if (!state.registrationCards || !state.registrationCards.contactData) {
          return null
        }
        let contactData = state.registrationCards.contactData
        if (contactData.additionalData) {
          contactData.additionalData.forEach(field => {
            contactData[camelCase(field.fieldName)] = field.value
          })
        }
        return contactData
      },
      settings: state => {
        return state.me.settings
      },
    }),
  },
  methods: {
    setFormValues () {
      for (var i = 0; i < this.fields.length; i++) {
        if (this.contactData && this.contactData[this.fields[i].name] !== undefined && this.contactData[this.fields[i].name] !== null) {
          this.formValues[this.fields[i].name] = this.contactData[this.fields[i].name]
        } else if (this.fields[i].name === 'email') {
          this.formValues[this.fields[i].name] = this.settings ? this.settings.email : null
        } else if (this.fields[i].name === 'languageCode') {
          this.formValues[this.fields[i].name] = this.settings ? this.settings.languageCode : null
        }
      }
    },
  },
  watch: {
    isCompleted: function (newValue, oldValue) {
      this.$emit('onIsCompletedChange', newValue)
    },
    registrationCardConfiguration () {
      if (!this.registrationCardConfiguration) {
        return
      }
      let contactDataFields = this.registrationCardConfiguration.steps.filter(step => step.type === 'CONTACT_DATA')[0]
      let fields = contactDataFields.configuration.fields
      let contactData = this.contactData
      for (var i = 0; i < fields.length; i++) {
        this.formValues[fields[i].fieldName] = contactData[fields[i].fieldName] !== undefined ? contactData[fields[i].fieldName] : null
      }
    },
    contactData: {
      immediate: true,
      handler: function (newValue, oldValue) {
        this.setFormValues()
      },
    },
    settings: {
      immediate: true,
      handler: function (value) {
        this.setFormValues()
      },
    },
  },
  mounted () {
    this.$watch(
      () => {
        return this.$refs.step3Form.flags.valid
      },
      (val) => {
        this.isCompleted = val
      },
      {
        immediate: true,
      }
    )
  },
  created () {
    this.$store.dispatch('me/getFacility')
  },
}
</script>
